import { getMoneyValue } from '@/framework/directive/index.js'
import { CATEGORY_CODE_MAP } from '@/store/dict/rentPlanDict.js'

export default function () {
  const rentInfo_formConfig = [
    {
      el: 'select',
      itemConfig: {
        label: '类别:',
        prop: 'rentCategory',
      },
      elConfig: {
        disabled: this.disabled,
        clearable: false,
        events: {
          change: (val) => {
            if (val !== CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
              this.queryFeeList().then((feeList) => this.addRequiredFee(feeList, 'fromEvent'))
            }
          },
        },
        options: { // 下拉数据
          label: 'name',
          value: 'code',
          list: this.categoryFilterList,
        },
      },
    },
    {
      el: 'date-picker',
      itemConfig: {
        label: '签署日期:',
        prop: 'signDate',
      },
      elConfig: {
        clearable: false,
        type: 'date',
        placeholder: '选择签署日期',
        pickerOptions: this.signInfoScrapDate,
      },
    },
    {
      el: 'date-picker',
      itemConfig: {
        label: '收款起止日期:',
        prop: 'startStopDate',
        ref: 'startStopDate',
      },
      elConfig: {
        pickerOptions: this.startStopInfoScrapDate,
        defaultValue: this.availablePaymentStartDate,
        events: {
          change: () => {
            this.queryFeeList().then((feeList) => {
              if (this.planId) {
                this.getPlanDetail(this.planId, true)
              } else {
                this.addRequiredFee(feeList, 'fromEvent')
              }
            })
          },
        },
      },
    },
    {
      el: 'input',
      itemConfig: {
        label: '赠送天数',
        prop: 'presentDays',
      },
      render: () => {
        const h = this.$createElement
        return h('el-form-item', {
          props: {
            prop: 'presentDays',
            label: '赠送天数:',
          },
        }, [
          h('el-input', {
            attrs: {
              disabled: this.disabled,
              placeholder: '请输入0~365之间的数字',
              maxlength: 3,
              style: 'width: 185px;', // 添加宽度属性
            },
            props: {
              value: this.rentInfo_model.presentDays,
            },
            on: {
              input: (value) => {
                const days = getMoneyValue(value) > 365 ? 365 : getMoneyValue(value)
                this.rentInfo_model.presentDays = days
                this.calculateContractDate()
              },
            },
          }, [
            h('template', { slot: 'append' }, '天'),
          ]),
        ])
      },
    },
  ]
  if (this.showDeposit) {
    rentInfo_formConfig.push({
      el: 'radio',
      itemConfig: {
        label: `是否平移原订单押金\n\r（已收押金：${Math.max(this.deposit.depositReceived, 0.00)}元）:`,
        prop: 'isTranDeposit',
        labelTip: {
          content: '勾选是：<br />1）押金会在原订单合同截止时将押金平移至新订单<br />2）新订单押金应收金额等于原订单应收押金金额<br />3）如在平移时押金仍有押金欠款，会在新订单继续要求司机补缴欠款<br />勾选否(原订单未收取押金或押金目前有在途单据时不可平移)：<br />1）原订单押金不会平移到新订单，需在原订单合同结束时结算并退款给司机<br />2）新订单需重新配置并收取押金',
        },
        disabled: !this.deposit.flag,
        'label-width': '300px',
        class: 'tran-deposit-radio',
      },
      elConfig: {
        options: { // 下拉数据
          label: 'label',
          value: 'value',
          list: [
            { label: '是', value: 1 },
            { label: '否', value: 0 },
          ],
        },
        events: {
          change: () => {
            this.queryFeeList().then((feeList) => this.addRequiredFee(feeList, 'fromEvent'))
          },
        },
      },
    })
  }
  const rentInfo_model = {
    rentCategory: CATEGORY_CODE_MAP.ZU_CHE, // 类别，默认租车
    signDate: new Date(), // 签署日期
    startStopDate: '', // 收款起止日期
    presentDays: null, // 赠送天数
    isTranDeposit: '', // 是否平移原订单押金 1-是 0-否
    contractDateText: '', // 合同起止日期文本 eg: 2023-07-01~2023-07-31 —————— 需在其他组件展示，未在当前组件绑定
    rentPeriodText: '', // 租期文本(天数) eg: 共7天 —————— 需在其他组件展示，未在当前组件绑定
    presentDaysText: '', // 赠送天数文本 eg: 0天 —————— 需在其他组件展示，未在当前组件绑定
    disabled: false, // 禁用 - 若是选择租赁方案，会置位true，此字段会传到组件 rentLeasePlanInfo 中，禁用新增费项按钮
  }
  const rentInfo_formRule = {
    rentCategory: [
      {
        required: true,
        message: '类别不能为空',
        trigger: 'change',
      },
    ],
    signDate: [
      {
        required: true,
        message: '请选择签署日期',
        trigger: 'change',
      },
    ],
    startStopDate: [
      {
        required: true,
        message: '请选择收款起止日期',
        trigger: 'change',
      },
    ],
    isTranDeposit: [
      {
        required: true,
        message: '请选择',
        trigger: 'change',
      },
    ],
  }
  return {
    rentInfo_formConfig,
    rentInfo_model,
    rentInfo_formRule,
  }
}
